<template>
  <div class="layout layout-fullpage">
    <div class="main-conn">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "layout-fullpage"
    };
  }
};
</script>

<style lang="scss">
@import "../../assets/scss/layout.scss";
</style>
